import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "GroupEdit" */ "./lazyIndex"), {
    name: "GroupEdit",
});

export const lazyEditGroup: LazyImport<typeof lazyIndex.editGroup, typeof lazyModule> = new LazyImport(lazyModule, m => m.editGroup);
